import styles from "./primitives.module.css";
import { cn } from "../../utils/cn";
import { mergeAria } from "../../utils/a11y";

const VARIANT = {
  primary: styles.btnPrimary,
  secondary: styles.btnSecondary,
  outlined: styles.btnOutlined,
  ghost: styles.btnGhost,
  danger: styles.btnDanger,
  icon: styles.btnIcon,
  fab: styles.btnFab,
};

export default function TRAButton({
  variant = "primary",
  type = "button",
  className,
  children,
  loading = false,
  disabled,
  "aria-label": ariaLabel,
  ...rest
}) {
  const isDisabled = disabled || loading;
  return (
    <button
      type={type}
      disabled={isDisabled}
      className={cn(
        styles.btn,
        VARIANT[variant] || VARIANT.primary,
        loading && styles.btnLoading,
        className
      )}
      {...mergeAria(
        {
          "aria-label": ariaLabel,
          "aria-busy": loading || undefined,
        },
        rest
      )}
    >
      {loading ? (
        <>
          <span className={styles.btnSpinner} aria-hidden />
          <span className="tra-sr-only">Loading</span>
        </>
      ) : (
        children
      )}
    </button>
  );
}
